module.exports = __webpack_public_path__ + "cad518ae310b98b6961c7e79c469805a.png";